var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / wallet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 12.4241H18V16.4241H16V12.4241Z",
    fill: "#292829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 7.42407V5.42407C20 4.32107 19.103 3.42407 18 3.42407H5C3.346 3.42407 2 4.77007 2 6.42407V18.4241C2 20.6251 3.794 21.4241 5 21.4241H20C21.103 21.4241 22 20.5271 22 19.4241V9.42407C22 8.32107 21.103 7.42407 20 7.42407ZM5 5.42407H18V7.42407H5C4.74252 7.41255 4.49941 7.30217 4.32128 7.11589C4.14315 6.92961 4.04373 6.68181 4.04373 6.42407C4.04373 6.16634 4.14315 5.91853 4.32128 5.73225C4.49941 5.54598 4.74252 5.43559 5 5.42407ZM20 19.4241H5.012C4.55 19.4121 4 19.2291 4 18.4241V9.23907C4.314 9.35207 4.647 9.42407 5 9.42407H20V19.4241Z",
    fill: "#292829"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.8b81bc5ea77c98f77aa99115f09b422f.svg";
export { ForwardRef as ReactComponent };